import { BaseLandscapeService } from '../../base-landscape.service';
import { LinkResponseDto } from '../dto/response/link-response.dto';
import { LinkSaveRequestDto } from '../dto/request/link-save-request.dto';
import { LinkUpdateRequestDto } from '../dto/request/link-update-request.dto';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';

class LinkService extends BaseLandscapeService {
  public async fetchLinkById(
    id: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<LinkResponseDto> {
    const response = await this.get<LinkResponseDto>(`/link/${id}`, {
      headers: {
        'accept-language': getLanguageKey(language),
      },
    });
    return response.data;
  }

  public async fetchManagementLinkById(id: string): Promise<LinkResponseDto> {
    const response = await this.get<LinkResponseDto>(`/link/${id}/management`);
    return response.data;
  }

  public async fetchLinksByCompactIndicatorId(
    compactIndicatorId: string
  ): Promise<LinkResponseDto[]> {
    const response = await this.get<LinkResponseDto[]>(
      `/link/bycompactindicatorid/${compactIndicatorId}`
    );
    return response.data;
  }

  public async saveLink(
    saveRequest: LinkSaveRequestDto
  ): Promise<LinkResponseDto> {
    const response = await this.post<LinkResponseDto>(`/link`, saveRequest);
    return response.data;
  }

  public async updateLink(
    updateRequest: LinkUpdateRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<LinkResponseDto> {
    const response = await this.put<LinkResponseDto>(`/link`, updateRequest, {
      headers: {
        'accept-language': getLanguageKey(language),
      },
    });
    return response.data;
  }

  public async deleteLink(
    existingId: string,
    compactId: string | null = null
  ): Promise<void> {
    await this.delete<void>(`/link/${existingId}`, {
      params: {
        compactId,
      },
    });
  }
}

const linkService = new LinkService();
export default linkService;
